import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { HashRouter } from 'react-router-dom';
import { App } from './App';
render(<HashRouter data-id="element-173" data-mp="1wbmonk0zlqm3">
    <App data-id="element-174" data-mp="1wd79uj1evx7a" />
  </HashRouter>, document.getElementById('root'));